import { render, staticRenderFns } from "./couponUser.vue?vue&type=template&id=287c9023&scoped=true&"
import script from "./couponUser.vue?vue&type=script&lang=js&"
export * from "./couponUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c9023",
  null
  
)

export default component.exports